import { Constantes } from "@/app/constants/constantsGlobal";
import { AlertType, TypeEnvironment } from "@/app/constants/enums";
import { useUser } from "@/app/context/UserContext";
import { getExcelPermissions } from "@/app/helpers/excel";
import { iProPermission } from "@/app/models/interfaceProject";
import { ChevronLeft, ChevronRight, FileUp, Trash2 } from "lucide-react";
import { useState, useRef, useEffect } from "react";
import ToggleSwitch from "../Elements/Core/ToggleSwitch";
import { useConfig } from "@/app/context/ConfigContext";
import IdentifierFieldConfigForm from "./LoginDisabled/IdentifierFieldConfigForm";
 

const ITEMS_PER_PAGE = 10;

const UserPermissions = () => {
  const { userProject, setUserProject,addAlert } = useUser();
  const [newEmail, setNewEmail] = useState("");
  const [error, setError] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const { queryParams} = useConfig();
  const [isEditingForm, setIsEditingForm] = useState(true);    
  const [selectedUsers, setSelectedUsers] = useState<string[]>([]);
  
  useEffect(() => {  
    /*if(userProject.project.env == TypeEnvironment.Prod){ 
      setIsEditingForm(false);
    } */
  }, []);

  const permissions = userProject?.project?.permissions?.filter(O=>!O.deleted) || [];
  const totalPages = Math.ceil(permissions.length / ITEMS_PER_PAGE);

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
 
  

  const handleAddUser = () => {
    if (!newEmail.trim()) {
      setError("El correo es obligatorio");
      return;
    }

    if (!emailRegex.test(newEmail)) {
      setError("Formato de correo inválido");
      return;
    }

    if (permissions.some((p) => p.email === newEmail)) {
      setError("Este correo ya está en la lista");
      return;
    }

    const newPermission:iProPermission = { email: newEmail, new: true, administrator:false /*domain:??*/ };

    setUserProject({
      ...userProject,
      project: {
        ...userProject.project,
        permissions: [newPermission,...permissions],
      },
    });

    setNewEmail("");
    setError("");
    setCurrentPage(1); 
  };
  const formatDate = (date?: string) => {
    if (!date) return "";

    return new Date(date).toLocaleDateString("es-ES", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };
  const handleRemoveUser = (vPersmio:iProPermission) => {
    setUserProject({
      ...userProject,
      project: {
        ...userProject.project,
        permissions: userProject.project.permissions.map((p) =>
          p.email === vPersmio.email ? { ...p, deleted: true } : p
        ),
      },
    });

    // setUserProject({
    //   ...userProject,
    //   project: {
    //     ...userProject.project,
    //     permissions: permissions.filter((p) => p.email !== email),
    //   },
    // });

    if (currentPage > 1 && (permissions.length - 1) % ITEMS_PER_PAGE === 0) {
      setCurrentPage(currentPage - 1);
    }
  };
  const handleDeleteSelected = () => {
    if (selectedUsers.length === 0) {
      addAlert("No hay usuarios seleccionados para eliminar.", AlertType.Warning);
      return;
    }

    setUserProject({
      ...userProject,
      project: {
        ...userProject.project,
        permissions: userProject.project.permissions.map((p) =>
          selectedUsers.includes(p.email) ? { ...p, deleted: true } : p
        ),
      },
    });

    addAlert(`Eliminados ${selectedUsers.length} usuarios`, AlertType.Success);
    setSelectedUsers([]);
  };
  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleAddUser();
    }
  };

  const paginatedPermissions = permissions.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );
  const toggleSelect = (email: string) => {
    setSelectedUsers((prev) =>
      prev.includes(email)
        ? prev.filter((u) => u !== email)
        : [...prev, email]
    );
  };

  const toggleSelectAll = () => {
    const currentEmails = paginatedPermissions.map((p) => p.email);
    const allSelected = currentEmails.every((email) => selectedUsers.includes(email));

    setSelectedUsers((prev) =>
      allSelected
        ? prev.filter((email) => !currentEmails.includes(email))
        : [...new Set([...prev, ...currentEmails])]
    );
  };
  // LIST MAILS
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  
  const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => { 
    if (event.target.files?.[0]) { 
      await handleFile(event.target.files[0]);
    }

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    } 
  };
   
  const handleFile = async (selectedFile: File) => {    
      
    if (!selectedFile) return; 
      if (selectedFile.size > Constantes.MAX_FILE_PDF_EXCEL_SIZE) { 
        addAlert(`El archivo supera el límite de ${(Constantes.MAX_FILE_PDF_EXCEL_SIZE/1024/1024)} MB`,AlertType.Warning)
        return;
      } 
      if(!(selectedFile.name.endsWith(".xls") || selectedFile.name.endsWith(".xlsx"))){
        addAlert(`Formato no permitido. Solo se aceptan archivos: .Xls, .xlsx `,AlertType.Warning)
        return; 
      }  
      const dataFile = await getExcelPermissions(selectedFile);
      const nuevosPermisos = validarPermisos(dataFile, userProject.project.permissions);  
      
      setUserProject({
        ...userProject,
        project: {
          ...userProject.project,
          permissions: [...nuevosPermisos,...permissions],
        },
      });
      addAlert(`Se ha agregado ${nuevosPermisos.length} permisos`,AlertType.Success); 
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    };
 
    const validarPermisos = (
      dataFile: iProPermission[],
      permisosExistentes: iProPermission[]
    ): iProPermission[] => {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    
      const existentesSet = new Set(
        permisosExistentes.filter(O=>!O.deleted).map((perm) => perm.email.toLowerCase())
      ); 
      const vistos = new Set<string>(); 
      const filtrados = dataFile.filter((perm) => {
        const email = perm.email?.toLowerCase().trim();      
        if (!emailRegex.test(email)) return false;
        if (existentesSet.has(email)) return false;
        if (vistos.has(email)) return false; 
        vistos.add(email); 
        return true;
      }); 
      return filtrados;
    };
    
    const toggleAdministrator = (vPersmio:iProPermission) => {
      setUserProject({
        ...userProject,
        project: {
          ...userProject.project,
          permissions: permissions.map((p) =>
            (p.email === vPersmio.email && !p.deleted) ? { ...p, administrator: !p.administrator } : p
          ),
        },
      });
    };

     
  return (
    <div className="flex justify-center items-center">
      <div className="w-full mx-4 ml-4">
       

        <h2 className="text-lg font-bold text-left">Correos con acceso</h2>

        {/* Formulario */}
        <div className="flex items-end gap-2"> 
          {isEditingForm&&(
          <div className="flex-1">
            <label className="block text-sm font-medium">Correo electrónico</label>
            <input
              type="email"
              placeholder="Correo electrónico"
              value={newEmail} 
              onKeyDown={handleKeyPress}
              onChange={(e) => setNewEmail(e.target.value.toLowerCase())}
              className="w-full border n-fmr-input my-2 px-3 py-2 border-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-700" 
            />
          </div>
          )}
          <div className="mb-2">
            <button 
              className={`w-full bg-blue-600 hover:bg-blue-700 text-white py-2 px-4 n-fmr-input focus:outline-none focus:ring-1 focus:ring-blue-700
                ${!isEditingForm?"hidden":""}`}
              onClick={handleAddUser}
              disabled={!isEditingForm} 
            >
              Agregar Correo
            </button>
          </div>
          <div className="mb-2">
            <input
                  ref={fileInputRef}
                  type="file"
                  accept={".xls, .xlsx"}
                  onChange={handleFileChange}
                  className="hidden"
              />
            <button
              onClick={() => fileInputRef.current?.click()}
              className={`flex items-center btn-inca-secondary justify-center px-2 py-2 w-10 h-10 rounded-full bg-gray-100 transition-colors border shadow-md  hover:bg-gray-200
                ${!isEditingForm?"hidden":""}`}
              disabled={!isEditingForm} 
            >
              <FileUp className="w-6 h-6 animate-fade-in" strokeWidth={1.5} /> 
            </button>
            {selectedUsers.length > 0 && (
            <button
              onClick={handleDeleteSelected}
              className="flex items-center text-white justify-center px-3 py-2 rounded bg-red-600 hover:bg-red-800 transition-colors border shadow-md"
            >
              <Trash2 className="w-4 h-4 mr-2" strokeWidth={1.5} />
              Eliminar seleccionados ({selectedUsers.length})
            </button>
          )}
          </div>
        </div>

        {error && <p className="text-red-500 text-sm">{error}</p>}
        
          <div className="flex items-center gap-2 mb-2 px-1">
          <input
            type="checkbox"
            checked={paginatedPermissions.length > 0 && paginatedPermissions.every((p) => selectedUsers.includes(p.email))}
            onChange={toggleSelectAll}
            className="accent-blue-600 w-4 h-4 cursor-pointer"
          />
          <span className="text-sm font-semibold text-gray-700">
            Seleccionar todos ({paginatedPermissions.length})
          </span>
        </div>
        <ul className="mt-4">
            <li key="sdfsdfsdfsdf" className="flex justify-between items-center p-1 border-b">
              <div className="font-bold">Usuario</div>
              <div className="flex items-center gap-2">
                <span className="font-bold">Admin</span>
                <span className="font-bold">/ Eliminar</span>              
              </div>              
            </li>

          {paginatedPermissions?.map((perm) => (
            <li key={perm.email} className="flex justify-between items-center p-2 border-b animate-fadeIn transition-all duration-300">
            <div className="flex items-center gap-3">
                <input
                  type="checkbox"
                  checked={selectedUsers.includes(perm.email)}
                  onChange={() => toggleSelect(perm.email)}
                  className="accent-blue-600 w-4 h-4 cursor-pointer"
                />
                <div className="relative group">
                  <span className="cursor-pointer">{perm.email}</span>

                  {perm.created_date && (
                    <div className="absolute left-0 top-6 z-10 hidden group-hover:block 
                                    bg-gray-800 text-white text-xs rounded px-2 py-1 shadow-lg whitespace-nowrap">
                      Creado: {formatDate(perm.created_date)}
                    </div>
                  )}
                </div>
              </div>
            <div className="flex items-center gap-2">
              <label className="flex items-center gap-1 text-sm mr-10">
                <input
                  type="checkbox"
                  checked={perm.administrator}
                  onChange={() => toggleAdministrator(perm)}
                  className={`h-5 w-5 text-blue-600 rounded focus:ring-2 focus:ring-blue-300 flex-shrink-0 ml-5" 
                      ${!isEditingForm?"hidden":""}`}
                  disabled={!isEditingForm} 
                />
              </label>
              <button
                onClick={() => handleRemoveUser(perm)}
                className={`flex items-center btn-inca-secondary justify-center px-2 py-2 rounded-full transition-colors border shadow-md
                    ${!isEditingForm?"hidden":""}`}
                disabled={!isEditingForm} 
              >
                <Trash2 className="w-4 h-4 animate-fade-in" strokeWidth={1.5} />
              </button>
            </div>
          </li>
           
          ))}
        </ul>

        {totalPages > 1 && ( 
            <div className="flex justify-end items-center mt-1"> 
                <button
                onClick={() => setCurrentPage(currentPage - 1)}
                disabled={currentPage === 1}
                className={`p-1 border bg-slate-50 text-blue-500 rounded-full disabled:opacity-50 mr-2 shadow-lg 
                    ${currentPage > 1 ? "hover:shadow-xl hover:bg-white hover:border-blue-400  ":" text-slate-400"}
                    `}
                >
                    <ChevronLeft />
                </button> 

                <span className="p-2 pt-2 pb-2 bg-blue-700 text-white rounded-full disabled:opacity-50 mr-2">
                 {currentPage}/{totalPages}
                </span>

                <button
                onClick={() => setCurrentPage(currentPage + 1)}
                disabled={currentPage === totalPages}
                className={`p-1 border bg-slate-50 text-blue-500 rounded-full disabled:opacity-50 mr-2 shadow-lg 
                    ${(currentPage === totalPages) ? "text-slate-400": "hover:shadow-xl hover:bg-white hover:border-blue-400 "}`}
                >
                    <ChevronRight />
                </button>

            </div> 
        )}
 


      </div>
    </div>
  );
};

export default UserPermissions;
